module.exports = __webpack_public_path__ + "img/fire-flame-11.e4b3e5cf.png";